import global from './global';
import vueFiles from './vueFiles';
document.addEventListener('DOMContentLoaded', (event) => {
	vueFiles.init();
	global.init();
});
